export default __webpack_public_path__ + "static/media/dollar.bff89c6c.svg";